/**
 * Sticky parameters are persistent query parameters in the URL.
 * This means, that once defined and the user accesses another path,
 * the sticky query parameters will be there as well.
 * To remove it, we simply change the query parameter to `undefined`,
 * under the hood, `undefined` sticky params are ignored and not replicated to another path.
 */
export const STICKY_QUERY_PARAMS = [
  /**
   * The user is redirected when needs to go through a step of the registration flow
   * then the `next` parameter is sent to capture the original URL the user was on (handled by python decorators)
   * at the end of the step, using the `next` parameter, we are able to redirect back to the original URL.
   */
  "next",
];
